import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgDocTwist(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M102.178 88.68c6.582-1.274 10.879-7.644 9.595-14.226L52.219 86.02c1.273 6.582-3.024 12.942-9.596 14.226l59.555-11.567Z"
        fill="#E2E8F0"
      />
      <path
        d="M76.384 19.53c6.582-1.274 12.942 3.023 14.226 9.595 2.316 11.911-4.974 38.049-2.659 49.96 1.274 6.582 7.644 10.88 14.226 9.595l-59.554 11.567c-6.583 1.274-12.942-3.023-14.227-9.595-2.315-11.911 4.975-38.048 2.66-49.96-1.274-6.582-7.644-10.879-14.227-9.595L76.384 19.53Z"
        fill="#F1F5F9"
      />
      <path
        d="M87.799 78.3a.8.8 0 0 1 .937.632c1.19 6.148 7.14 10.163 13.288 8.963a.8.8 0 0 1 .307 1.57c-7.016 1.37-13.807-3.211-15.165-10.228a.8.8 0 0 1 .633-.937Z"
        fill="#0F172A"
      />
      <path
        d="M87.86 23.483a12.115 12.115 0 0 0-11.476-3.953L16.829 31.097c6.583-1.274 12.942 3.023 14.227 9.596.343 1.749.475 3.812.455 6.087l42.386-8.23c-1.274-6.583 3.023-12.943 9.595-14.227l4.358-.85.01.01Z"
        fill="#E2E8F0"
      />
      <path
        d="M16.83 31.097c-6.573 1.274-10.87 7.644-9.596 14.227l59.554-11.568c-1.274-6.582 3.023-12.942 9.596-14.226L16.829 31.097Z"
        fill="#F1F5F9"
      />
      <path
        d="M76.231 18.735a.8.8 0 0 1 .307 1.57c-6.14 1.2-10.154 7.14-8.964 13.29a.8.8 0 0 1-.633.937L44.312 38.93a.8.8 0 0 1-.304-1.57l21.868-4.251c-.883-6.729 3.614-13.057 10.355-14.374Z"
        fill="#0F172A"
      />
      <path
        d="M78.375 61.586a.8.8 0 0 1 .305 1.57l-41.688 8.1a.8.8 0 0 1-.305-1.572l41.688-8.098ZM77.708 74.083a.8.8 0 0 1 .305 1.57l-41.689 8.09a.8.8 0 1 1-.305-1.571l41.689-8.089ZM78.274 80.15a.8.8 0 0 1 .305 1.57l-41.689 8.1a.8.8 0 0 1-.304-1.571l41.688-8.1ZM78.375 67.663a.8.8 0 1 1 .305 1.57l-41.688 8.089a.8.8 0 1 1-.305-1.57l41.688-8.09ZM79.598 55.175a.8.8 0 1 1 .305 1.57l-24.58 4.773a.8.8 0 0 1-.305-1.57l24.58-4.773ZM80.61 48.097a.8.8 0 0 1 .305 1.57L55.17 54.664a.8.8 0 0 1-.304-1.57l25.743-4.996ZM80.61 41.02a.8.8 0 1 1 .304 1.57L55.02 47.615a.8.8 0 0 1-.305-1.57L80.61 41.02Z"
        fill="#B3C0D0"
      />
      <path
        d="M42.257 49.948a2.602 2.602 0 0 1 2.418-.349l.167.068c.4.179.766.467 1.041.835l.003.003 5.044 6.818a2.584 2.584 0 0 1-.557 3.627 2.607 2.607 0 0 1-3.463-.34l-.168-.206-2.385-3.225-1.62 3.663c-.575 1.31-2.112 1.9-3.421 1.334a2.586 2.586 0 0 1-1.338-3.424l3.425-7.755.792.347-.05-.023-.732-.324c.195-.438.487-.783.838-1.043l.006-.006Zm-2.816 9.454-.002.004a.985.985 0 0 0 .511 1.301 1.009 1.009 0 0 0 1.323-.508v-.004l1.988-4.495-1.37-1.85-2.45 5.552Zm5.665-3.9 2.922 3.95.065.079c.336.37.911.437 1.338.126a.984.984 0 0 0 .212-1.383v-.001l-3.609-4.877-.928 2.106Zm-.915-4.374a.999.999 0 0 0-1.315.518l-.01-.005a.993.993 0 0 0 .035.87l.071.11.003.003 1.036 1.4.698-1.586v-.002a.975.975 0 0 0-.107-.977 1.072 1.072 0 0 0-.411-.33Z"
        fill="#78B441"
      />
      <path
        d="M78.345 67.774a.8.8 0 1 1 .304 1.57l-24.327 4.722a.8.8 0 1 1-.304-1.57l24.327-4.722Z"
        fill="#B3C0D0"
      />
    </svg>
  )
}
export default wrapIllustration(SvgDocTwist)
